import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchSiteSettings,
  saveSiteSettings,
  applySiteSettingsCSSVars
} from '../App/SiteSettings.actions';
import API from '../../api';
import { API_URL } from '../../constants';
import { dataURLtoFile } from '../../helpers';

const styles = {
  container: {
    maxWidth: 600,
    margin: '40px auto',
    padding: 20,
    fontFamily: 'sans-serif'
  },
  loginContainer: {
    maxWidth: 400,
    margin: '100px auto',
    padding: 20,
    textAlign: 'center',
    fontFamily: 'sans-serif'
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
    padding: '8px 0',
    borderBottom: '1px solid #eee'
  },
  label: {
    flex: 1,
    fontSize: 14,
    fontWeight: 500
  },
  colorInput: {
    width: 60,
    height: 36,
    border: '1px solid #ccc',
    borderRadius: 4,
    cursor: 'pointer',
    padding: 2
  },
  select: {
    padding: '8px 12px',
    fontSize: 14,
    borderRadius: 4,
    border: '1px solid #ccc'
  },
  button: {
    padding: '10px 24px',
    fontSize: 16,
    fontWeight: 600,
    color: '#fff',
    backgroundColor: '#1976d2',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    marginTop: 16
  },
  buttonDisabled: {
    opacity: 0.6,
    cursor: 'not-allowed'
  },
  passwordInput: {
    padding: '10px 14px',
    fontSize: 16,
    borderRadius: 4,
    border: '1px solid #ccc',
    width: '100%',
    maxWidth: 300,
    marginBottom: 12
  },
  error: {
    color: '#d32f2f',
    fontSize: 14,
    marginBottom: 12
  },
  success: {
    color: '#2e7d32',
    fontSize: 14,
    marginBottom: 12
  },
  section: {
    marginBottom: 24
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
    color: '#333',
    borderBottom: '2px solid #1976d2',
    paddingBottom: 4
  },
  preview: {
    width: 40,
    height: 20,
    borderRadius: 4,
    border: '1px solid #ccc',
    marginLeft: 8,
    display: 'inline-block'
  }
};

class AdminSettings extends Component {
  state = {
    password: '',
    authenticated: false,
    error: '',
    success: '',
    primaryBarColor: '#222222',
    secondaryBarColor: '#4b4b4b',
    tileBackgroundColor: '',
    tileTextColor: '',
    settingsHeaderColor: '',
    navbarPosition: 'below',
    logoUrl: '',
    appName: '',
    boardBackgroundColor: '',
    outputBarColor: '',
    outputBarTextColor: '',
    toolbarIconColor: '',
    selectionHighlightColor: '',
    tileBorderColor: '',
    tileBorderRadius: '',
    tileShape: '',
    tileShadow: '',
    tileFontSize: '',
    tileFontWeight: '',
    tileFontFamily: '',
    tilesPerRow: 0,
    tileSpacing: '',
    modalTemplate: '',
    modalSize: '',
    modalBackground: '',
    tileTemplate: '',
    outputBarPosition: '',
    toolbarLayout: '',
    toolbarPosition: '',
    saving: false,
    // Board Export/Import state
    boards: [],
    selectedBoardId: '',
    selectedBoard: null,
    exporting: false,
    exportImportMessage: '',
    // Folder Export/Import state
    folders: [],
    selectedFolderId: '',
    selectedFolder: null,
    folderExporting: false,
    folderImporting: false,
    folderExportImportMessage: ''
  };

  componentDidMount() {
    const { siteSettings } = this.props;
    if (siteSettings) {
      this.setState({
        primaryBarColor: siteSettings.primaryBarColor || '#222222',
        secondaryBarColor: siteSettings.secondaryBarColor || '#4b4b4b',
        tileBackgroundColor: siteSettings.tileBackgroundColor || '',
        tileTextColor: siteSettings.tileTextColor || '',
        settingsHeaderColor: siteSettings.settingsHeaderColor || '',
        navbarPosition: siteSettings.navbarPosition || 'below',
        logoUrl: siteSettings.logoUrl || '',
        appName: siteSettings.appName || '',
        boardBackgroundColor: siteSettings.boardBackgroundColor || '',
        outputBarColor: siteSettings.outputBarColor || '',
        outputBarTextColor: siteSettings.outputBarTextColor || '',
        toolbarIconColor: siteSettings.toolbarIconColor || '',
        selectionHighlightColor: siteSettings.selectionHighlightColor || '',
        tileBorderColor: siteSettings.tileBorderColor || '',
        tileBorderRadius: siteSettings.tileBorderRadius || '',
        tileShape: siteSettings.tileShape || '',
        tileShadow: siteSettings.tileShadow || '',
        tileFontSize: siteSettings.tileFontSize || '',
        tileFontWeight: siteSettings.tileFontWeight || '',
        tileFontFamily: siteSettings.tileFontFamily || '',
        tilesPerRow: siteSettings.tilesPerRow || 0,
        tileSpacing: siteSettings.tileSpacing || '',
        modalTemplate: siteSettings.modalTemplate || '',
        modalSize: siteSettings.modalSize || '',
        modalBackground: siteSettings.modalBackground || '',
        tileTemplate: siteSettings.tileTemplate || '',
        outputBarPosition: siteSettings.outputBarPosition || '',
        toolbarLayout: siteSettings.toolbarLayout || '',
        toolbarPosition: siteSettings.toolbarPosition || ''
      });
    }
    this.fetchAllBoards();
  }

  fetchAllBoards = async () => {
    try {
      const response = await API.getBoards({ limit: 10000 });
      const allBoards = response.data || [];
      const boards = allBoards.filter(b => !b.parent);
      const folders = allBoards.filter(b => b.parent);
      this.setState({ boards, folders });
    } catch (err) {
      console.error('Failed to fetch boards:', err);
    }
  };

  handleBoardSelect = async (boardId) => {
    if (!boardId) {
      this.setState({ selectedBoardId: '', selectedBoard: null });
      return;
    }
    this.setState({ selectedBoardId: boardId, selectedBoard: null });
    try {
      const board = await API.getBoard(boardId);
      this.setState({ selectedBoard: board });
    } catch (err) {
      this.setState({ exportImportMessage: 'Failed to load board: ' + err.message });
    }
  };

  embedImages = async (boards) => {
    for (const board of boards) {
      for (const tile of (board.tiles || [])) {
        if (
          tile.image &&
          tile.image.includes('/uploads/')
        ) {
          try {
            const imageUrl = tile.image.startsWith('http')
              ? tile.image
              : `${API_URL}${tile.image}`;
            const response = await fetch(imageUrl);
            const blob = await response.blob();
            const reader = new FileReader();
            tile.image = await new Promise((resolve) => {
              reader.onloadend = () => resolve(reader.result);
              reader.readAsDataURL(blob);
            });
          } catch (err) {
            // Keep original URL if fetch fails
          }
        }
      }
    }
  };

  handleExport = async () => {
    const { selectedBoard } = this.state;
    if (!selectedBoard) return;

    this.setState({ exporting: true, exportImportMessage: '' });
    try {
      const rootFolder = {
        originalId: selectedBoard._id || selectedBoard.id,
        name: selectedBoard.name,
        nameKey: selectedBoard.nameKey,
        description: selectedBoard.description,
        locale: selectedBoard.locale,
        isPublic: selectedBoard.isPublic,
        hidden: selectedBoard.hidden,
        isFixed: selectedBoard.isFixed,
        grid: selectedBoard.grid,
        cellSize: selectedBoard.cellSize,
        caption: selectedBoard.caption,
        backgroundColor: selectedBoard.backgroundColor,
        tiles: (selectedBoard.tiles || []).map(t => ({ ...t }))
      };

      const subFolders = await this.collectSubFolders(selectedBoard);
      const folders = [rootFolder, ...subFolders];

      await this.embedImages(folders);

      const exportData = {
        exportVersion: 1,
        exportType: 'folder',
        exportDate: new Date().toISOString(),
        folders
      };

      const json = JSON.stringify(exportData, null, 2);
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${selectedBoard.nameKey || selectedBoard.name || 'board'}_export.json`;
      a.click();
      URL.revokeObjectURL(url);

      this.setState({
        exporting: false,
        exportImportMessage: `Exported "${selectedBoard.nameKey || selectedBoard.name}" with ${folders.length} board(s).`
      });
    } catch (err) {
      this.setState({
        exporting: false,
        exportImportMessage: 'Export failed: ' + err.message
      });
    }
  };

  handleFolderSelect = async (folderId) => {
    if (!folderId) {
      this.setState({ selectedFolderId: '', selectedFolder: null });
      return;
    }
    this.setState({ selectedFolderId: folderId, selectedFolder: null });
    try {
      const folder = await API.getBoard(folderId);
      this.setState({ selectedFolder: folder });
    } catch (err) {
      this.setState({ folderExportImportMessage: 'Failed to load folder: ' + err.message });
    }
  };

  collectSubFolders = async (board, collected = []) => {
    for (const tile of (board.tiles || [])) {
      if (tile.loadBoard) {
        const alreadyCollected = collected.find(c =>
          (c.originalId === tile.loadBoard) || (c.originalId === (tile.loadBoard._id || tile.loadBoard))
        );
        if (alreadyCollected) continue;
        try {
          const subBoardId = tile.loadBoard._id || tile.loadBoard;
          const subBoard = await API.getBoard(subBoardId);
          if (subBoard) {
            const subFolder = {
              originalId: subBoard._id || subBoard.id,
              name: subBoard.name,
              nameKey: subBoard.nameKey,
              description: subBoard.description,
              locale: subBoard.locale,
              isPublic: subBoard.isPublic,
              hidden: subBoard.hidden,
              isFixed: subBoard.isFixed,
              grid: subBoard.grid,
              cellSize: subBoard.cellSize,
              caption: subBoard.caption,
              backgroundColor: subBoard.backgroundColor,
              tiles: (subBoard.tiles || []).map(t => ({ ...t }))
            };
            collected.push(subFolder);
            await this.collectSubFolders(subBoard, collected);
          }
        } catch (err) {
          console.error('Failed to fetch sub-folder:', tile.loadBoard, err);
        }
      }
    }
    return collected;
  };

  handleFolderExport = async () => {
    const { selectedFolder } = this.state;
    if (!selectedFolder) return;

    this.setState({ folderExporting: true, folderExportImportMessage: '' });
    try {
      const folder = {
        originalId: selectedFolder._id || selectedFolder.id,
        name: selectedFolder.name,
        nameKey: selectedFolder.nameKey,
        description: selectedFolder.description,
        locale: selectedFolder.locale,
        isPublic: selectedFolder.isPublic,
        hidden: selectedFolder.hidden,
        isFixed: selectedFolder.isFixed,
        grid: selectedFolder.grid,
        cellSize: selectedFolder.cellSize,
        caption: selectedFolder.caption,
        backgroundColor: selectedFolder.backgroundColor,
        tiles: (selectedFolder.tiles || []).map(t => ({ ...t }))
      };

      // Recursively collect all sub-folder boards
      const subFolders = await this.collectSubFolders(selectedFolder);
      const allFolders = [folder, ...subFolders];

      await this.embedImages(allFolders);

      const exportData = {
        exportVersion: 1,
        exportType: 'folder',
        exportDate: new Date().toISOString(),
        folders: allFolders
      };

      const json = JSON.stringify(exportData, null, 2);
      const blob = new Blob([json], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${selectedFolder.nameKey || selectedFolder.name || 'folder'}_folder_export.json`;
      a.click();
      URL.revokeObjectURL(url);

      this.setState({
        folderExporting: false,
        folderExportImportMessage: `Exported folder "${selectedFolder.nameKey || selectedFolder.name}" with ${allFolders.length} board(s) and ${allFolders.reduce((sum, f) => sum + (f.tiles || []).length, 0)} tile(s).`
      });
    } catch (err) {
      this.setState({
        folderExporting: false,
        folderExportImportMessage: 'Export failed: ' + err.message
      });
    }
  };

  handleFolderImport = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    this.setState({ folderImporting: true, folderExportImportMessage: '' });
    try {
      const text = await file.text();
      const data = JSON.parse(text);

      // Accept both folder format and old board format
      const folders = data.folders || data.boards;
      if (!data.exportVersion || !folders || !folders.length) {
        throw new Error('Invalid export file format.');
      }

      // Re-upload base64 images for all folders
      for (const folder of folders) {
        for (const tile of (folder.tiles || [])) {
          if (tile.image && tile.image.startsWith('data:')) {
            try {
              const imgFile = dataURLtoFile(tile.image, `import_${tile.id || 'tile'}.png`);
              const newUrl = await API.uploadFile(imgFile, imgFile.name);
              tile.image = newUrl;
            } catch (err) {
              // Keep as base64 if upload fails
            }
          }
        }
      }

      // Map from old originalId -> new board _id
      const idMap = {};

      // Step 1: Create all sub-folder boards first (folders[1..n] are sub-folders)
      // Skip folders[0] which is the root folder — it will be created via createTile
      for (let i = 1; i < folders.length; i++) {
        const subFolder = folders[i];
        try {
          const boardData = {
            name: subFolder.name || subFolder.nameKey || 'Imported Sub-Folder',
            nameKey: subFolder.nameKey || subFolder.name || 'Imported Sub-Folder',
            description: subFolder.description,
            locale: subFolder.locale,
            isPublic: true,
            hidden: subFolder.hidden || false,
            isFixed: subFolder.isFixed || false,
            grid: subFolder.grid,
            cellSize: subFolder.cellSize,
            caption: subFolder.caption,
            backgroundColor: subFolder.backgroundColor,
            tiles: [],
            author: { id: 'admin-import' },
            email: 'admin@import'
          };
          const created = await API.createBoard(boardData);
          idMap[subFolder.originalId] = created._id || created.id;
        } catch (err) {
          console.error('Failed to create sub-folder board:', subFolder.nameKey, err);
        }
      }

      // Step 2: Create the root folder tile on the root board
      const rootFolder = folders[0];
      try {
        const folderTile = {
          label: rootFolder.nameKey || rootFolder.name || 'Imported Folder',
          labelKey: rootFolder.nameKey || rootFolder.name || 'Imported Folder',
          image: rootFolder.caption || '',
          backgroundColor: rootFolder.backgroundColor || '',
          type: 'folder',
          boardId: 'root'
        };
        const createdTile = await API.createTile(folderTile);
        const newRootFolderId = createdTile.loadBoard;
        idMap[rootFolder.originalId] = newRootFolderId;

        // Step 3: For each folder, remap loadBoard references and create tiles
        for (const folder of folders) {
          const newBoardId = idMap[folder.originalId];
          if (!newBoardId || !folder.tiles || folder.tiles.length === 0) continue;

          const tilesForFolder = folder.tiles.map(t => {
            const mapped = { ...t, _id: undefined, id: undefined };
            // Remap loadBoard to new ID if it's a sub-folder reference
            if (mapped.loadBoard && idMap[mapped.loadBoard]) {
              mapped.loadBoard = idMap[mapped.loadBoard];
            }
            return mapped;
          });
          await API.createTiles({ tilesData: tilesForFolder, boardId: newBoardId });
        }
      } catch (err) {
        console.error('Failed to create root folder:', rootFolder.name, err);
      }

      await this.fetchAllBoards();
      this.setState({
        folderImporting: false,
        folderExportImportMessage: `Imported ${folders.length} board(s) successfully.`
      });
    } catch (err) {
      this.setState({
        folderImporting: false,
        folderExportImportMessage: 'Import failed: ' + err.message
      });
    }
    event.target.value = '';
  };

  handlePasswordSubmit = e => {
    e.preventDefault();
    if (this.state.password.length > 0) {
      this.setState({ authenticated: true, error: '' });
    }
  };

  handleSave = async () => {
    this.setState({ saving: true, error: '', success: '' });
    try {
      const {
        password,
        primaryBarColor,
        secondaryBarColor,
        tileBackgroundColor,
        tileTextColor,
        settingsHeaderColor,
        navbarPosition,
        logoUrl,
        appName,
        boardBackgroundColor,
        outputBarColor,
        outputBarTextColor,
        toolbarIconColor,
        selectionHighlightColor,
        tileBorderColor,
        tileBorderRadius,
        tileShape,
        tileShadow,
        tileFontSize,
        tileFontWeight,
        tileFontFamily,
        tilesPerRow,
        tileSpacing,
        modalTemplate,
        modalSize,
        modalBackground,
        tileTemplate,
        outputBarPosition,
        toolbarLayout,
        toolbarPosition
      } = this.state;
      await this.props.saveSiteSettings(
        {
          primaryBarColor,
          secondaryBarColor,
          tileBackgroundColor,
          tileTextColor,
          settingsHeaderColor,
          navbarPosition,
          logoUrl,
          appName,
          boardBackgroundColor,
          outputBarColor,
          outputBarTextColor,
          toolbarIconColor,
          selectionHighlightColor,
          tileBorderColor,
          tileBorderRadius,
          tileShape,
          tileShadow,
          tileFontSize,
          tileFontWeight,
          tileFontFamily,
          tilesPerRow: parseInt(tilesPerRow, 10) || 0,
          tileSpacing,
          modalTemplate,
          modalSize,
          modalBackground,
          tileTemplate,
          outputBarPosition,
          toolbarLayout,
          toolbarPosition
        },
        password
      );
      this.setState({ success: 'Settings saved!', saving: false });
    } catch (err) {
      this.setState({
        error: err?.response?.data?.message || 'Failed to save. Check your password.',
        saving: false,
        success: ''
      });
    }
  };

  handleFieldChange = (field, value) => {
    this.setState({ [field]: value }, () => {
      applySiteSettingsCSSVars(this.state);
    });
  };

  render() {
    if (!this.state.authenticated) {
      return (
        <div style={styles.loginContainer}>
          <h2>Admin Settings</h2>
          <p style={{ color: '#666', marginBottom: 20 }}>
            Enter admin password to continue
          </p>
          <form onSubmit={this.handlePasswordSubmit}>
            <input
              type="password"
              placeholder="Admin password"
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              style={styles.passwordInput}
              autoFocus
            />
            <br />
            <button type="submit" style={styles.button}>
              Enter
            </button>
          </form>
        </div>
      );
    }

    const { saving, error, success } = this.state;

    return (
      <div style={styles.container}>
        <h2>Site Customization Settings</h2>

        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}

        {/* Section 1: Branding */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Branding</div>

          <div style={styles.field}>
            <span style={styles.label}>Logo URL (displayed in toolbar)</span>
            <input
              type="text"
              value={this.state.logoUrl}
              onChange={e => this.handleFieldChange('logoUrl', e.target.value)}
              placeholder="https://example.com/logo.png"
              style={{ ...styles.passwordInput, maxWidth: 300, marginBottom: 0 }}
            />
          </div>
          {this.state.logoUrl && (
            <div style={{ marginBottom: 16, textAlign: 'center' }}>
              <img
                src={this.state.logoUrl}
                alt="Logo preview"
                style={{ maxHeight: 50, maxWidth: 200 }}
                onError={e => { e.target.style.display = 'none'; }}
              />
            </div>
          )}

          <div style={styles.field}>
            <span style={styles.label}>App Name (displayed in toolbar)</span>
            <input
              type="text"
              value={this.state.appName}
              onChange={e => this.handleFieldChange('appName', e.target.value)}
              placeholder="My AAC App"
              style={{ ...styles.passwordInput, maxWidth: 250, marginBottom: 0 }}
            />
          </div>
        </div>

        {/* Section 2: Bar Colors */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Bar Colors</div>

          <div style={styles.field}>
            <span style={styles.label}>Primary Bar Color (Navbar, License bar)</span>
            <input
              type="color"
              value={this.state.primaryBarColor || '#222222'}
              onChange={e => this.handleFieldChange('primaryBarColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Secondary Bar Color (Edit toolbar)</span>
            <input
              type="color"
              value={this.state.secondaryBarColor || '#4b4b4b'}
              onChange={e => this.handleFieldChange('secondaryBarColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Output Bar Background Color</span>
            <input
              type="color"
              value={this.state.outputBarColor || '#ffffff'}
              onChange={e => this.handleFieldChange('outputBarColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Output Bar Text Color</span>
            <input
              type="color"
              value={this.state.outputBarTextColor || '#000000'}
              onChange={e => this.handleFieldChange('outputBarTextColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Toolbar Icon Color</span>
            <input
              type="color"
              value={this.state.toolbarIconColor || '#ffffff'}
              onChange={e => this.handleFieldChange('toolbarIconColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>
        </div>

        {/* Section 3: Tile Appearance */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Tile Appearance</div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Design Template</span>
            <select
              value={this.state.tileTemplate}
              onChange={e => this.handleFieldChange('tileTemplate', e.target.value)}
              style={styles.select}
            >
              <option value="">None (use individual settings below)</option>
              <option value="classic">Classic (default look)</option>
              <option value="flat">Flat Modern</option>
              <option value="cards3d">3D Cards</option>
              <option value="bubbles">Rounded Bubbles</option>
              <option value="compact">Compact</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Background Color (default)</span>
            <input
              type="color"
              value={this.state.tileBackgroundColor || '#ffffff'}
              onChange={e => this.handleFieldChange('tileBackgroundColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Text Color</span>
            <input
              type="color"
              value={this.state.tileTextColor || '#000000'}
              onChange={e => this.handleFieldChange('tileTextColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Border Color</span>
            <input
              type="color"
              value={this.state.tileBorderColor || '#000000'}
              onChange={e => this.handleFieldChange('tileBorderColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Shape</span>
            <select
              value={this.state.tileShape}
              onChange={e => this.handleFieldChange('tileShape', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (rectangle)</option>
              <option value="default">Rectangle</option>
              <option value="rounded">Rounded Rectangle</option>
              <option value="circle">Circle</option>
              <option value="hexagon">Hexagon</option>
              <option value="diamond">Diamond</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Corner Rounding</span>
            <select
              value={this.state.tileBorderRadius}
              onChange={e => this.handleFieldChange('tileBorderRadius', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (medium)</option>
              <option value="none">None (square)</option>
              <option value="small">Small</option>
              <option value="medium">Medium</option>
              <option value="large">Large</option>
              <option value="round">Round</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Shadow</span>
            <select
              value={this.state.tileShadow}
              onChange={e => this.handleFieldChange('tileShadow', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (medium)</option>
              <option value="none">No shadow</option>
              <option value="light">Light</option>
              <option value="medium">Medium</option>
              <option value="heavy">Heavy</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Font Size</span>
            <select
              value={this.state.tileFontSize}
              onChange={e => this.handleFieldChange('tileFontSize', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (medium)</option>
              <option value="small">Small</option>
              <option value="medium">Medium</option>
              <option value="large">Large</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Font Weight</span>
            <select
              value={this.state.tileFontWeight}
              onChange={e => this.handleFieldChange('tileFontWeight', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (bold)</option>
              <option value="normal">Normal</option>
              <option value="bold">Bold</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Font Family</span>
            <select
              value={this.state.tileFontFamily}
              onChange={e => this.handleFieldChange('tileFontFamily', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (system)</option>
              <option value="arial">Arial</option>
              <option value="verdana">Verdana</option>
              <option value="georgia">Georgia (serif)</option>
              <option value="comic-sans">Comic Sans</option>
              <option value="courier">Courier (monospace)</option>
              <option value="trebuchet">Trebuchet MS</option>
            </select>
          </div>
        </div>

        {/* Section 4: Settings & UI */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Settings & UI</div>

          <div style={styles.field}>
            <span style={styles.label}>Settings Header Color (modal top bar)</span>
            <input
              type="color"
              value={this.state.settingsHeaderColor || '#1976d2'}
              onChange={e => this.handleFieldChange('settingsHeaderColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Selection Highlight Color (edit mode)</span>
            <input
              type="color"
              value={this.state.selectionHighlightColor || '#2196f3'}
              onChange={e => this.handleFieldChange('selectionHighlightColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Modal Design Template</span>
            <select
              value={this.state.modalTemplate}
              onChange={e => this.handleFieldChange('modalTemplate', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (Material UI)</option>
              <option value="default">Default</option>
              <option value="modern">Modern Minimal</option>
              <option value="glass">Glassmorphism</option>
              <option value="bold">Bold / Colorful</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Modal Size</span>
            <select
              value={this.state.modalSize}
              onChange={e => this.handleFieldChange('modalSize', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (fullscreen)</option>
              <option value="fullscreen">Fullscreen</option>
              <option value="floating">Floating (centered card)</option>
              <option value="halfscreen">Half Screen</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Modal Background</span>
            <select
              value={this.state.modalBackground}
              onChange={e => this.handleFieldChange('modalBackground', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (none)</option>
              <option value="default">None</option>
              <option value="blurred">Blurred</option>
              <option value="gradient">Gradient</option>
              <option value="pattern">Pattern</option>
            </select>
          </div>
        </div>

        {/* Section 5: Layout */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>Layout</div>

          <div style={styles.field}>
            <span style={styles.label}>Navbar Position</span>
            <select
              value={this.state.navbarPosition}
              onChange={e => this.handleFieldChange('navbarPosition', e.target.value)}
              style={styles.select}
            >
              <option value="below">Below Output (default)</option>
              <option value="above">Above Output</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Board Background Color</span>
            <input
              type="color"
              value={this.state.boardBackgroundColor || '#ffffff'}
              onChange={e => this.handleFieldChange('boardBackgroundColor', e.target.value)}
              style={styles.colorInput}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tiles Per Row (0 = auto/responsive)</span>
            <input
              type="number"
              min="0"
              max="12"
              value={this.state.tilesPerRow}
              onChange={e => this.handleFieldChange('tilesPerRow', e.target.value)}
              style={{ ...styles.passwordInput, maxWidth: 80, marginBottom: 0, textAlign: 'center' }}
            />
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Tile Spacing</span>
            <select
              value={this.state.tileSpacing}
              onChange={e => this.handleFieldChange('tileSpacing', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (normal)</option>
              <option value="tight">Tight (4px)</option>
              <option value="normal">Normal (10px)</option>
              <option value="wide">Wide (16px)</option>
              <option value="extra-wide">Extra Wide (24px)</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Output Bar Position</span>
            <select
              value={this.state.outputBarPosition}
              onChange={e => this.handleFieldChange('outputBarPosition', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (in flow)</option>
              <option value="top">Fixed Top</option>
              <option value="bottom">Fixed Bottom</option>
              <option value="left">Fixed Left</option>
              <option value="right">Fixed Right</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Toolbar Layout</span>
            <select
              value={this.state.toolbarLayout}
              onChange={e => this.handleFieldChange('toolbarLayout', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (two bars)</option>
              <option value="compact">Compact (license in edit toolbar)</option>
              <option value="sidebyside">Side by Side (one combined bar)</option>
            </select>
          </div>

          <div style={styles.field}>
            <span style={styles.label}>Toolbar Position</span>
            <select
              value={this.state.toolbarPosition}
              onChange={e => this.handleFieldChange('toolbarPosition', e.target.value)}
              style={styles.select}
            >
              <option value="">Default (in flow)</option>
              <option value="top">Fixed Top</option>
              <option value="bottom">Fixed Bottom</option>
              <option value="left">Fixed Left</option>
              <option value="right">Fixed Right</option>
            </select>
          </div>
        </div>

        <button
          onClick={this.handleSave}
          disabled={saving}
          style={{
            ...styles.button,
            ...(saving ? styles.buttonDisabled : {})
          }}
        >
          {saving ? 'Saving...' : 'Save Settings'}
        </button>

        {/* Section 6: Board Export / Import */}
        <div style={{ ...styles.section, marginTop: 40 }}>
          <div style={styles.sectionTitle}>Board Export / Import</div>

          <div style={styles.field}>
            <span style={styles.label}>Select Board</span>
            <select
              value={this.state.selectedBoardId}
              onChange={e => this.handleBoardSelect(e.target.value)}
              style={styles.select}
            >
              <option value="">-- Choose a board --</option>
              {this.state.boards.map(b => (
                <option key={b._id || b.id} value={b._id || b.id}>
                  {b.nameKey || b.name || b._id || b.id}
                </option>
              ))}
            </select>
          </div>

          {this.state.selectedBoard && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${this.state.selectedBoard.grid?.columns || 5}, 1fr)`,
              gap: 4,
              marginBottom: 16,
              maxHeight: 400,
              overflow: 'auto',
              border: '1px solid #ddd',
              borderRadius: 4,
              padding: 8,
              backgroundColor: '#f5f5f5'
            }}>
              {(this.state.selectedBoard.tiles || []).map((tile, idx) => (
                <div key={tile.id || idx} style={{
                  backgroundColor: tile.backgroundColor || '#fff',
                  border: `2px solid ${tile.borderColor || '#ccc'}`,
                  borderRadius: 6,
                  padding: 4,
                  textAlign: 'center',
                  minHeight: 80,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden'
                }}>
                  {tile.image && (
                    <img
                      src={tile.image}
                      alt={tile.label || ''}
                      style={{ maxWidth: '80%', maxHeight: 50, objectFit: 'contain' }}
                      onError={e => { e.target.style.display = 'none'; }}
                    />
                  )}
                  <span style={{
                    fontSize: 11,
                    fontWeight: 600,
                    marginTop: 2,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%'
                  }}>
                    {tile.label || tile.labelKey || ''}
                  </span>
                  {tile.loadBoard && (
                    <span style={{ fontSize: 9, color: '#666' }}>folder</span>
                  )}
                </div>
              ))}
            </div>
          )}

          <button
            onClick={this.handleExport}
            disabled={!this.state.selectedBoard || this.state.exporting}
            style={{
              ...styles.button,
              marginTop: 0,
              ...(!this.state.selectedBoard || this.state.exporting ? styles.buttonDisabled : {})
            }}
          >
            {this.state.exporting ? 'Exporting...' : 'Export Board'}
          </button>

          {this.state.exportImportMessage && (
            <p style={{ ...styles.success, marginTop: 8 }}>{this.state.exportImportMessage}</p>
          )}
        </div>

        {/* Section 7: Folder Export / Import */}
        <div style={{ ...styles.section, marginTop: 40 }}>
          <div style={styles.sectionTitle}>Folder Export / Import</div>

          <div style={styles.field}>
            <span style={styles.label}>Select Folder</span>
            <select
              value={this.state.selectedFolderId}
              onChange={e => this.handleFolderSelect(e.target.value)}
              style={styles.select}
            >
              <option value="">-- Choose a folder --</option>
              {this.state.folders.map(f => (
                <option key={f._id || f.id} value={f._id || f.id}>
                  {f.nameKey || f.name || f._id || f.id}
                </option>
              ))}
            </select>
          </div>

          {this.state.selectedFolder && (
            <div style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${this.state.selectedFolder.grid?.columns || 5}, 1fr)`,
              gap: 4,
              marginBottom: 16,
              maxHeight: 400,
              overflow: 'auto',
              border: '1px solid #ddd',
              borderRadius: 4,
              padding: 8,
              backgroundColor: '#f5f5f5'
            }}>
              {(this.state.selectedFolder.tiles || []).map((tile, idx) => (
                <div key={tile.id || idx} style={{
                  backgroundColor: tile.backgroundColor || '#fff',
                  border: `2px solid ${tile.borderColor || '#ccc'}`,
                  borderRadius: 6,
                  padding: 4,
                  textAlign: 'center',
                  minHeight: 80,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  overflow: 'hidden'
                }}>
                  {tile.image && (
                    <img
                      src={tile.image}
                      alt={tile.label || ''}
                      style={{ maxWidth: '80%', maxHeight: 50, objectFit: 'contain' }}
                      onError={e => { e.target.style.display = 'none'; }}
                    />
                  )}
                  <span style={{
                    fontSize: 11,
                    fontWeight: 600,
                    marginTop: 2,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%'
                  }}>
                    {tile.label || tile.labelKey || ''}
                  </span>
                  {tile.loadBoard && (
                    <span style={{ fontSize: 9, color: '#666' }}>folder</span>
                  )}
                </div>
              ))}
            </div>
          )}

          <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={this.handleFolderExport}
              disabled={!this.state.selectedFolder || this.state.folderExporting}
              style={{
                ...styles.button,
                marginTop: 0,
                ...(!this.state.selectedFolder || this.state.folderExporting ? styles.buttonDisabled : {})
              }}
            >
              {this.state.folderExporting ? 'Exporting...' : 'Export Folder'}
            </button>

            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 14, fontWeight: 500 }}>Import:</span>
              <input
                type="file"
                accept=".json"
                onChange={this.handleFolderImport}
                disabled={this.state.folderImporting}
                style={{ fontSize: 14 }}
              />
            </div>
          </div>

          {this.state.folderImporting && (
            <p style={{ fontSize: 14, color: '#1976d2', marginTop: 8 }}>Importing...</p>
          )}
          {this.state.folderExportImportMessage && (
            <p style={{ ...styles.success, marginTop: 8 }}>{this.state.folderExportImportMessage}</p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  siteSettings: state.app.siteSettings
});

const mapDispatchToProps = { fetchSiteSettings, saveSiteSettings };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminSettings);
